<template>
  <div class="grid grid-cols-12">
    <div class="col-span-3
                    p-8 pt-14 lg:p-12 lg:pb-6 lg:pl-14
                    bg-transaction-gradient">
      <div class="text-xl font-bold text-text leading-tight ">
        <slot name="title"/>
      </div>
    </div>
    <div class="col-span-9 pt-14 pl-8 pr-8 lg:pt-11 lg:pl-12 lg:pr-17">
      <div class="flex items-center space-x-4">
        <slot name="form-menu"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftGradientBlockLayoutHead"
}
</script>